const areas = [
  { text: 'Pori', value: 'pori_kesk' },
  { text: 'Pori (Noormarkku)', value: 'pori_noor' },
  { text: 'Pori (Reposaari)', value: 'pori_repo' },
  { text: 'Pori (Lavia)', value: 'pori_lavia' },
  { text: 'Kristiinankaupunki', value: 'kk' },
  { text: 'Harjavalta', value: 'harjavalta' },
  { text: 'Muu', value: 'muu' },
];

const buildingTypes = [
  { text:  'Omakotitalo', value: 'okt' },
  { text:  'Rivitalo', value: 'rt' },
  { text:  'Kerrostalo', value: 'kt' },
  { text:  'Liikerakennus', value: 'lr' },
  { text:  'Teollisuus', value: 'teol' },
  { text:  'Halli', value: 'halli' },
  { text:  'Palvelurakennus', value: 'palv' },
  { text:  'Muu rakennus', value: 'muu' },
];

const heatingMethods = [
  { text: 'Uudiskohde', value: 'uudiskohde' },
  { text: 'Öljy', value: 'oljy' },
  { text: 'Maalämpö', value: 'maalampo' },
  { text: 'Ilmavesilämpöpumppu', value: 'ilmavesi' },
  { text: 'Sähkö', value: 'sahko' },
];

const years = [
  { text: 'Ennen 1990', value: '0' },
  { text: '1990-2009', value: '1' },
  { text: '2009 jälkeen', value: '2' },
];

export default { areas, buildingTypes, heatingMethods, years };
